// frontend/src/paginas/tienda_publica/orden_resumen/helpers.js

export const AGENCY_URLS = [
  { keywords: ['mrw'], name: 'MRW', url: 'https://mrwve.com/', color: 'bg-orange-600' },
  { keywords: ['zoom', 'grupo zoom'], name: 'ZOOM', url: 'https://zoom.red/tracking-de-envios-personas/', color: 'bg-blue-600' },
  { keywords: ['tealca'], name: 'Tealca', url: 'https://www.tealca.com/rastrear-envio/', color: 'bg-blue-800' },
  { keywords: ['domesa'], name: 'Domesa', url: 'https://www.portal.domesa.com.ve/', color: 'bg-red-700' },
  { keywords: ['liberty', 'liberty express'], name: 'Liberty Express', url: 'https://libertyexpress.com/es-ve/rastreo/', color: 'bg-red-600' },
];

export const getAgencyConfig = (agencyString) => {
  if (!agencyString) return null;
  const lower = agencyString.toLowerCase();
  return AGENCY_URLS.find(a => a.keywords.some(k => lower.includes(k)));
};